import React from "react"
import { useFormSubmissionAuditTrailContext } from "contexts/FormSubmissionAuditTrailContext"
import { conversationShape } from "utils/propTypeShapes"
import { Checkbox } from "shared/checkboxes"

const ShowConversationAuditsCheckbox = ({ conversation }) => {
  const {
    auditsForConversationShown,
    hideAuditsForConversation,
    showAuditsForConversation,
  } = useFormSubmissionAuditTrailContext()

  const { id: conversationId, title } = conversation

  const auditsShown = auditsForConversationShown({ conversationId })

  const toggleAuditVisibility = () => (
    auditsShown ? hideAuditsForConversation({ conversationId }) : showAuditsForConversation({ conversationId })
  )

  const checkboxId = `${conversationId}-conversation-checkbox-filter`

  return (
    <div
      className="mb-2 rounded-md cursor-pointer p-2 border border-lightgray-3
                 text-sm font-medium w-full flex items-center justify-between input-focus-ring"
      onClickCapture={toggleAuditVisibility}
    >
      <label
        className="screenreader-only"
        htmlFor={checkboxId}
      >{`Show ${title} audit items`}
      </label>
      <span className="flex-grow mr-4" aria-hidden>{title}</span>
      <Checkbox value={auditsShown} uuid={checkboxId} />
    </div>
  )
}

ShowConversationAuditsCheckbox.propTypes = {
  conversation: conversationShape.isRequired,
}

export default ShowConversationAuditsCheckbox
